import { Flex } from '@chakra-ui/react'
import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import Home from '../components/Home'

export default function Homepage() {
  return (
    <>
    <Header/>
    <Home/>
    <Footer/>
    </>
  )
}
